import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { Permissao } from '@models/enums/permissao';
import { PermissionService } from '@services/permission.service';
import { AuthService } from '../auth/auth.service';

/**
 * Diretiva estrutural que exibe ou remove o elemento do DOM
 * conforme a permissão do usuário. Com uma lista, exibe se o usuário
 * tiver ao menos uma delas.
 *
 * @example
 * <button *hasPermission="Permissao.EditarContaCaixa">Criar Conta</button>
 * <div *hasPermission="[Permissao.RealizarVistoria, Permissao.EditarRoteiroVistoria]">...</div>
 */
@Directive({ selector: '[hasPermission]', standalone: false })
export class HasPermissionDirective implements OnInit, OnDestroy {

  @Input() hasPermission!: Permissao | Permissao[];

  // O menu (onde essa diretiva é mais usada) é montado no shell do app, fora de qualquer rota
  // protegida — na primeira renderização o login ainda pode não ter acontecido, então reavaliar
  // só uma vez no ngOnInit deixaria os itens escondidos para sempre até um F5. Reavalia a cada
  // mudança de isLoggedIn (login/refresh/logout) para refletir a permissão assim que o token chega.
  private subscription: Subscription;

  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
    private permissionService: PermissionService,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.subscription = this.authService.isLoggedIn.subscribe(() => this.updateView());
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  private updateView(): void {
    this.viewContainer.clear();
    const permissoes = Array.isArray(this.hasPermission) ? this.hasPermission : [this.hasPermission];
    if (permissoes.some(permissao => this.permissionService.has(permissao))) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
